export default {
  cl_main: '#4F4F4F',
  cl_tit_white: '#F2F2F2',
  cl_red: '#DA6862',
  cl_border: '#212121',
  cl_white: '#FFFFFF',
  cl_txt: '#7E7E7E',
}
